export class Location {
  state: string;
  countyId: string;
  countyName: string;
  zipCode: number;
}
